import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["key"],
  _excluded2 = ["key"];
import React from "react";
import DialogActions from "./components/DialogActions";
import DialogContent from "./components/DialogContent";
import DialogHeader from "./components/DialogHeader";
import VARIANT_OPTIONS from "./constants";
import { BaseDialogContainer } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Dialog(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? "md" : _ref$width,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "transactional" : _ref$variant,
    headerProps = _ref.headerProps,
    content = _ref.content,
    actionsProps = _ref.actionsProps;
  // `key` must reach JSX directly: spread, React 18.3 warns and React 19 drops it.
  var _ref2 = actionsProps !== null && actionsProps !== void 0 ? actionsProps : {},
    actionsKey = _ref2.key,
    actionsRest = _objectWithoutProperties(_ref2, _excluded);
  var _ref3 = headerProps !== null && headerProps !== void 0 ? headerProps : {},
    headerKey = _ref3.key,
    headerRest = _objectWithoutProperties(_ref3, _excluded2);
  return /*#__PURE__*/_jsxs(BaseDialogContainer, {
    width: width,
    children: [/*#__PURE__*/_jsx(DialogContent, {
      content: content
    }), VARIANT_OPTIONS[variant].actionsAllowed && actionsProps && /*#__PURE__*/_jsx(DialogActions, _extends({
      variant: variant
    }, actionsRest), actionsKey), /*#__PURE__*/_jsx(DialogHeader, _extends({
      variant: variant
    }, headerRest), headerKey)]
  });
}
export default Dialog;